

import React from "react";
import { Layout } from "antd";

import { Wells } from "./Wells.js";
import { WellSettings } from "./WellSettings";

const { Content, Sider } = Layout;
export const WellBaseView = () => {
  return (
    <Layout>
      <Content>
        <Layout style={{ background: "#fff" }}>
          <Sider
            width={550}
            
             style={{ background: "#fff", paddingLeft: "20px", width: "30%" }}
          >
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <Wells/>
                </div>
              </div>
            </div>
          </Sider>
          <Content>
         <WellSettings/>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
};

